import { ReactSVG } from "react-svg";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import { optimizeURL } from "@/utils/url";
import { CustomLink } from "../CustomLink";

interface TranscriptButtonProps {
  href: string;
  ariaLabel: string;
  className?: string;
}

export const TranscriptButton = ({
  href,
  ariaLabel,
  className = "",
}: TranscriptButtonProps) => {
  const { getIcon } = useGlobalContext();

  return (
    <CustomLink
      className={className}
      href={optimizeURL(href)}
      target="_blank"
      aria-label={ariaLabel}
    >
      <ReactSVG
        width={32}
        height={32}
        src={getIcon("video-controls-transcript")}
        wrapper="svg"
        beforeInjection={(svg) => {
          svg.setAttribute("alt", "transcript icon");
          svg.setAttribute("aria-hidden", "true");
        }}
        aria-hidden
        className="vds-icon"
      />
    </CustomLink>
  );
};
